// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".statusMessage_statusMessage__2Oodm {\n  position: absolute;\n  top: 43%;\n  transform: translateY(-50%);\n  z-index: 2;\n  font-weight: 500;\n  border-radius: 0 4px 4px 0;\n  color: var(--text-primary);\n  background-color: var(--black-10);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n}", ""]);
// Exports
exports.locals = {
	"statusMessage": "statusMessage_statusMessage__2Oodm"
};
module.exports = exports;
